import { useProjectStore } from "stores/projectStore"

/**
 * A project and its owner, for reads that reach another project (another wave, a tracker member).
 * Its owner comes with it from the project list or the tracker, never from the open project.
 */
export interface ProjectRef {
  id: string
  owner: string
}

/**
 * The open project's owner, sent with every provenance call about the open project. The hooks
 * read it here so callers pass only the project id. Empty until the project is loaded: the
 * queries wait for it rather than send an empty owner.
 */
export const useProjectOwner = (): string =>
  useProjectStore((s) => s.project.Created_by)
